<template>
  <PageWrapper
    :isLoading="isLoading"
    :hasFilters="true"
    @submitFilters="getAllLessonCategoryDetails"
  >
    <template #title> آمار فروش گروه‌بندی های درس </template>
    <template #filters>
      <LessonCategoryPicker
        class="filters-width w-24"
        closeOnSelect
        @getLessonCategory="setLessonCategoryId"
      ></LessonCategoryPicker>
    </template>
    <BRow
      class="mb-2"
      v-if="lessonCategoryDetailsList && lessonCategoryDetailsList.length"
    >
      <BCol cols="12" class="mb-1">
        <hr />
      </BCol>
      <BCol cols="12" md="4">
        <p>
          مبلغ کل فروش پکیج ها:
          <span class="text-success">
            {{ Intl.NumberFormat("en-US").format(totalSale) }}
          </span>
          تومان
        </p>
      </BCol>
      <BCol cols="12" md="4">
        <p>
          تعداد کل کاربر های خرید کرده:
          <span class="text-warning">
            {{ totalUser }}
          </span>
          نفر
        </p>
      </BCol>
    </BRow>
    <CustomTable
      v-if="lessonCategoryDetailsList"
      :pageNumber="0"
      :count="0"
      :totalCount="0"
      :tableColumns="tableColumns"
      :tableItems="lessonCategoryDetailsList"
    >
    </CustomTable>
  </PageWrapper>
</template>
<script>
export default {
  mounted() {
    this.getAllLessonCategoryDetails();
  },
  data() {
    return {
      isLoading: false,
      lessonCategoryDetailsList: null,
      totalUser: null,
      totalSale: null,
      lessonCategoryFilters: {
        lessonCategoryId: null,
      },
      tableColumns: [
        {
          key: "lessonCategoryId",
          label: "شناسه",
        },
        {
          key: "lessonCategoryTitle",
          label: "عنوان گروه بندی درس",
        },
        {
          key: "totalSale",
          label: "فروش کلی گروه",
          formatter: (value) =>
            `${value ? Intl.NumberFormat("en-US").format(value) : "0"} تومان`,
        },
        {
          key: "ordersCount",
          label: "تعداد سفارشات گروه بندی",
          formatter: (value) => `${value} سفارش`,
        },
        {
          key: "usersCount",
          label: "تعداد کاربران",
          formatter: (value) => `${value} نفر`,
        },
      ],
    };
  },
  methods: {
    setLessonCategoryId(lessonCategoryId) {
      this.lessonCategoryFilters.lessonCategoryId = lessonCategoryId;
    },
    async getAllLessonCategoryDetails() {
      try {
        this.isLoading = true;
        const _this = this;
        const getLessonCategoryOrderDetails = new GetLessonCategoryOrderDetails(
          _this
        );
        getLessonCategoryOrderDetails.setRequestParam(
          _this.lessonCategoryFilters
        );
        await getLessonCategoryOrderDetails.fetch((response) => {
          if (response.isSuccess) {
            _this.totalUser = response.data.totalUser;
            _this.totalSale = response.data.totalSale;
            _this.lessonCategoryDetailsList = response.data.data;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTable,
    LessonCategoryPicker,
    BRow,
    BCol,
    BLink,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import LessonCategoryPicker from "@/views/components/LessonCategories/LessonCategoryPicker.vue";
import { GetLessonCategoryOrderDetails } from "@/libs/Api/Order";
import { BRow, BCol, BLink } from "bootstrap-vue";
</script>
